<template>
  <div>
    <search v-if="searchDisable !== true" v-model="search" />
    <div
      :class="` position-relative overflow-hidden ${loading ? 'loading' : ''}`"
    >
      <div class="row mb-4">
        <div class="col-12">
          <ul class="status">
            <li v-if="isAdd">
              <button
                class="btn btn-info btn-sm btn-icon"
                @click="$modal.show(modalCreate)"
              >
                <span class="ti-plus"></span>
                Добавить
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-sm btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>
            <li v-if="isUpdate">
              <button class="btn btn-sm btn-success btn-icon" @click="getList">
                <span class="ti-reload"></span>
                Обновить 
              </button>
            </li>
            <li v-if="functions && functions.length && checked.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-sm btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="checked.length">
              <button
                class="btn btn-sm btn-warning btn-icon"
                @click="checked = []"
              >
                <span class="ti-close"></span>
                Сброить {{ checked.length }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-4 text-right">
        <h5
          class="modal-title badge badge-warning mr-3"
          v-if="checked && checked.length"
        >
          Выбрано: {{ checked.length }}
        </h5>

        <h5 v-if="items.last_page" class="modal-title badge badge-danger">
          {{
            items.last_page ? "Всего: " + items.total + " шт." : "Загрузка..."
          }}
        </h5>
      </div>
      <div class="row" v-if="columns && columns.length && items">
        <div class="col-12">
          <div class="table-full-width table-responsive">
            <paper-table
              v-show="items.data.length"
              type="hover"
              :cardLink="cardLink"
              :data="items.data"
              :columns="columns"
              :removeItem="removeItem"
              @changeCheckbox="changeCheckbox"
              @changeRadio="changeRadio"
              :checkSet="checked"
            ></paper-table>
            <h4 v-if="items.data.length === 0">Нет данных</h4>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <h5
          class="modal-title badge badge-warning mr-3"
          v-if="checked && checked.length"
        >
          Выбрано: {{ checked.length }}
        </h5>

        <h5 v-if="items.last_page" class="modal-title badge badge-danger">
          {{
            items.last_page ? "Всего: " + items.total + " шт." : "Загрузка..."
          }}
        </h5>
      </div>
      <div class="fixed-pagination">
        <div class="responsive-pagination">
          <paginate
            v-if="items.last_page"
            v-show="items.last_page > 1"
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'Назад'"
            :nextText="'Далее'"
          ></paginate>
        </div>
      </div>
    </div>
    <add-item
      v-if="fields && fields.length && setLink"
      :fields="fields"
      :getList="getList"
      :setLink="setLink"
      :modalCreate="modalCreate"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import Search from "./Search";
import AddItem from "./Modals/AddItem";
import { mapState } from "vuex";
export default {
  name: "List",
  data() {
    return {
      checked: [],
      radio: null,
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        data: [],
      },
    };
  },
  components: {
    PaperTable,
    AddItem,
    Search,
  },
  props: [
    "searchDisable",
    "setLink",
    "itemLink",
    "title",
    "columns",
    "removeLink",
    "cardLink",
    "modalCreate",
    "disable_add",
    "is_filter",
    "isAdd",
    "isUpdate",
    "functions",
    "fields",
    "params",
  ],
  computed: {
    ...mapState(["newOrder","lastUpdate"]),
    page() {
      return this.items.current_page;
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val){
      if (val){
        setTimeout(() => {
            this.getList();
        },50);
      
      }
    },
    params: {
      handler: function (val) {
        if (val.clear===true){
          this.checked = [];
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    changeRadio(val) {
      this.radio = val;
      this.$emit("change", val);
    },
    changeCheckbox(val) {
      this.checked = val;
      this.$emit("change", val);
    },
    removeItem(itemID) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .delete(this.removeLink, {
              data: { id: itemID },
            })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },

    getList(loading = true) {
      let params = this.params ? this.params : {};
      params["page"] = this.items.current_page;
      params["search"] = this.search;
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          this.items = response.data;
        })
        .catch(() => {
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>
